// <!-- GRACE:MODULE_START name="ui_landing" -->
// <!-- GRACE:DEPENDENCY target="ui_asr" -->
// <!-- GRACE:DEPENDENCY target="ui_gpt" -->
// <!-- GRACE:DEPENDENCY target="ui_display" -->
// <!-- GRACE:DEPENDENCY target="ui_status" -->
import Header from "./Header";
import HeroSection from "./HeroSection";
import Card from "./Card";

interface ProcessingState {
  status: 'idle' | 'uploading' | 'processing' | 'completed' | 'error';
  progress: number;
  estimatedTime: number;
  operationId: string;
  error: string;
}

interface FactsPageProps {
  // Header props
  onNavigate: (page: 'facts' | 'template' | 'dialog') => void;
  
  // Hero props
  isRecording: boolean;
  transcription: string;
  processingState: ProcessingState;
  audioUrl: string | null;
  audioBlob: Blob | null;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onTranscriptionChange: (text: string) => void;
  onFileChange: (file: File) => void;
  onClearTranscription: () => void;
  onCopyTranscription: () => void;
  onDownloadTranscription: () => void;
  
  // GPT processing props
  prompt: string;
  gptResult: string;
  gptProcessing: boolean;
  onPromptChange: (text: string) => void;
  onProcessWithGPT: () => void;
  onCopyGPTResult: () => void;
  onDownloadGPTResult: () => void;
}

// <!-- GRACE:CONTRACT function="FactsPage" -->
export default function FactsPage({
  onNavigate,
  isRecording,
  transcription,
  processingState,
  audioUrl,
  audioBlob,
  onStartRecording,
  onStopRecording,
  onTranscriptionChange,
  onFileChange,
  onClearTranscription,
  onCopyTranscription,
  onDownloadTranscription,
  prompt,
  gptResult,
  gptProcessing,
  onPromptChange,
  onProcessWithGPT,
  onCopyGPTResult,
  onDownloadGPTResult,
}: FactsPageProps) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <Header activePage="facts" onNavigate={onNavigate} />

      {/* Hero */}
      <HeroSection
        isRecording={isRecording}
        transcription={transcription}
        processingState={processingState}
        audioUrl={audioUrl}
        audioBlob={audioBlob}
        onStartRecording={onStartRecording}
        onStopRecording={onStopRecording}
        onTranscriptionChange={onTranscriptionChange}
        onFileChange={onFileChange}
        onClear={onClearTranscription}
        onCopy={onCopyTranscription}
        onDownload={onDownloadTranscription}
      />

      {/* GPT Processing Section */}
      <Card title="Обработка текста GPT">
        <div className="grid gap-6 md:grid-cols-2">
          {/* Левая колонка: Промпт и кнопка */}
          <div className="space-y-3">
            <div>
              <div className="mb-1 text-sm font-medium text-gray-700">
                Промпт для GPT
              </div>
              <textarea
                value={prompt}
                onChange={(e) => onPromptChange(e.target.value)}
                className="h-40 w-full resize-y rounded-xl border p-3 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900/10"
              />
            </div>
            <button
              onClick={onProcessWithGPT}
              disabled={gptProcessing || !transcription.trim()}
              className={`w-full rounded-xl px-4 py-2 text-sm font-medium text-white ${
                gptProcessing || !transcription.trim()
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gray-900 hover:bg-gray-800'
              }`}
            >
              {gptProcessing ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Обработка...
                </span>
              ) : (
                'Отправить на обработку'
              )}
            </button>
          </div>

          {/* Правая колонка: Результат обработки */}
          <div className="space-y-3">
            <div>
              <div className="mb-1 text-sm font-medium text-gray-700">
                Результат обработки
              </div>
              <textarea
                readOnly
                value={gptResult}
                className="h-40 w-full resize-y rounded-xl border bg-gray-50 p-3 text-sm"
              />
            </div>
            <div className="flex gap-2 text-xs">
              <button
                onClick={onCopyGPTResult}
                className="rounded-lg border px-3 py-1.5 hover:bg-gray-50"
              >
                Копировать
              </button>
              <button
                onClick={onDownloadGPTResult}
                className="rounded-lg border px-3 py-1.5 hover:bg-gray-50"
              >
                Скачать
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_landing" -->
